// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Vaša Firebase konfiguracija
const firebaseConfig = {
  apiKey: "AIzaSyAlAttddmNvmK3ZQakwP-ifmSMdSYE7ku8",
  authDomain: "beauty-concept-veronika-app.firebaseapp.com",
  projectId: "beauty-concept-veronika-app",
  storageBucket: "beauty-concept-veronika-app.appspot.com",
  messagingSenderId: "693883003789",
  appId: "1:693883003789:web:49e3e54239b102714cd3c4",
  measurementId: "G-T6ZD5075FQ",
};

// Inicijalizacija Firebase aplikacije
const app = initializeApp(firebaseConfig);

// Inicijalizacija Firestore-a
const db = getFirestore(app);

// Inicijalizacija Firebase funkcija
const functions = getFunctions(app);

// Inicijalizacija Firebase analitike (opciono)
const analytics = getAnalytics(app);

// Eksport Firebase servisa
export { db, functions, analytics };
